export default __webpack_public_path__ + "media/images/icons/consultancy-plus-divide-659fdde30b7460f856a22cf2f9c48b22.svg";